import {
  DropdownMenu,
  GhostIconButton,
  MenuItem,
  MenuSection,
  Text,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  id: string;
}

export function ActionsDropdown(props: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = props;

  return (
    <DropdownMenu
      triggerButton={
        <GhostIconButton
          testID="profile-listing-item-expand-button"
          size="small"
          icon="more_horiz"
          aria-label={t("Expand menu")}
        />
      }
      onItemAction={(menuItem) => {
        switch (menuItem) {
          case "view-profile":
            navigate(`/profiles/${id}`, {
              state: {
                last: {
                  href: `${location.pathname}${location.search}`,
                },
              },
            });
            break;
          case "copy-link":
            navigator.clipboard.writeText(
              `${window.location.origin}${location.pathname}/${id}`
            );
            break;
        }
      }}
      placement="bottom right"
    >
      <MenuSection>
        <MenuItem id="view-profile">
          <Text style="input/text-field" testID="view-profile-button">
            {t("View profile")}
          </Text>
        </MenuItem>
        <MenuItem id="copy-link">
          <Text style="input/text-field" testID="copy-profile-link-button">
            {t("Copy profile link")}
          </Text>
        </MenuItem>
      </MenuSection>
    </DropdownMenu>
  );
}
